import React from "react";
import ReactDOM from "react-dom/client";
import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { setupAxiosInterceptors } from "./utils/axiosInterceptor";
import { store } from "./redux/store";
import { Provider } from "react-redux";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LocationProvider } from "./context/LocationContext";

setupAxiosInterceptors(store);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <LocationProvider>
      <>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          theme="colored"
        />
      </>
    </LocationProvider>
  </Provider>
);

reportWebVitals();
